module.exports = __webpack_public_path__ + "static/michel-8966b22788fabf26a4d912886ab1e224.jpg";